import { Interface } from "ethers/lib/utils"
import ERC1155 from "../abi/ERC1155.json"
import LIKESV0 from "../abi/LikesV0.json"
import LIKESPROXYV0 from "../abi/LikesProxyV0.json"

const ERC1155Interface = new Interface(ERC1155.abi)
export { ERC1155, ERC1155Interface }


const LIKESV0Interface = new Interface(LIKESV0.abi)
export { LIKESV0, LIKESV0Interface }


const LIKESPROXYV0Interface = new Interface(LIKESPROXYV0.abi)
export { LIKESPROXYV0, LIKESPROXYV0Interface }